import React, { FunctionComponent, Suspense } from 'react'
import PropTypes from 'prop-types'
import Field from '../../fields'

interface ShiftPasswordFormProps {
  fields: any
  formId: string
  onCancelEditPassword?: () => void
  type?: 'create' | 'edit'
}

const ShiftPasswordForm: FunctionComponent<ShiftPasswordFormProps> = ({
  fields,
  formId,
  onCancelEditPassword,
  type = 'create',
}) => {
  if (!fields) return null

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
       <Suspense fallback={<div>Loading...</div>}>
          <Field
            className="title-field"
            formId={formId}
            keys="title"
            label="Title"
            note="For your reference as an admin e.g. Morning, Afternoon, Night"
            required
            type="text"
            values={fields}
          />
        </Suspense>
      </div>
      <div style={{ marginBottom: 20 }}>
      <Suspense fallback={<div>Loading...</div>}>
        <Field
          className="duration-field"
          formId={formId}
          keys={['startTime', 'endTime']}
          label="Start / End (HH:mm)"
          placeholders={['Start', 'End']}
          type="duration"
          values={fields}
          required
        />
        </Suspense>
      </div>
      <div style={{ marginBottom: 20 }}>
      <Suspense fallback={<div>Loading...</div>}>
        <Field
          formId={formId}
          keys="length"
          label="Access Time (hours)"
          note="This is the length of time before Carers will be asked again to enter the Shift Password."
          options={{
            numeral: true,
            numeralThousandsGroupStyle: 'none',
          }}
          required
          type="number"
          values={fields}
          positiveValuesOnly
          acceptZero={false}
          formFieldStyle={{
            width: '100%',
          }}
          style={{ maxWidth: 'unset' }}
        />
        </Suspense>
      </div>
      {type === 'edit' ? (
        <Field
          className="change-password-field"
          formId={formId}
          keys={['password', 'password_confirm']}
          label="Shift password"
          onCancel={onCancelEditPassword}
          type="changePassword"
          values={fields}
        />
      ) : (
        <Suspense fallback={<div>Loading...</div>}>
        <Field
          className="new-password-field"
          formId={formId}
          inputType="password"
          keys={['password', 'password_confirm']}
          label="Shift Password"
          placeholders={['New password', 'Confirm password']}
          required
          type="multiText"
          values={fields}
        />
        </Suspense>
      )}
    </div>
  )
}

export default ShiftPasswordForm
